var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container",class:{ active: _vm.isLoading }},[_c('transition',[(_vm.isLoading)?_c('div',{staticClass:"loading-indicator"}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }